import { GlobalMessagesButton } from "@/modules/messages/GlobalMessagesButton";
import { GlobalDialButton } from "@/modules/voice/GlobalDialButton";
import { useOrgModules } from "@/modules/useOrgModules";

/** Global header quick-comms: message + dial popovers (Messages app only). */
export const GlobalCommsHeaderActions = () => {
  const { isEnabled } = useOrgModules();
  if (!isEnabled("messages")) return null;
  return (
    <>
      <GlobalMessagesButton />
      <GlobalDialButton />
    </>
  );
};
